import React, {Component} from 'react';
import { translate } from 'react-admin';
import {configAPI} from '../config'
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';

class TotalTemplates extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.timer = setInterval(()=> this.getItems(), 5000);
    }
    componentWillUnmount() {
        clearInterval(this.timer);
        this.timer = null;
    }
    
    getItems() {
        const {push} = this.props;
        const ReqGetTemplates = new Request(configAPI.api.prod+'GetTemplates?token='+sessionStorage.B.encodeDecode());
        fetch(ReqGetTemplates)
            .then(response => { return response.json();})
            .then(Templates => {
                if (Templates.responseStatus==='OK') {
                    this.setState({totalTemplates: Templates.templates.length});
                }
            else {
                push('/login');
                sessionStorage.clear();
            }
        })
    }

    render() {
        return <span>{this.state.totalTemplates}</span>
    }

}
export default connect(null, {
    push: pushAction,
})(translate(TotalTemplates));